import { DropdownOption } from '@wm-front/core'
import { DeviceIconPipe } from '@wm-front/shared/pipes'
import { DeviceTypeEnum } from '@wm-front/client/graphql'
import {
  BuildingOfDevicesOptionFragment,
  DevicesOptionFragment,
} from '../data/graphql/fetch-devices-options.types'

export interface DeviceOptions {
  device: DevicesOptionFragment
  building: BuildingOfDevicesOptionFragment
}

/**
 * Merge two dropdown option array and get only unique
 * @param { DropdownOption[] } currArray
 * @param { DropdownOption[] } newArray
 * @returns
 */
export function mergeArrays(
  currArray: DropdownOption[],
  newArray: DropdownOption[]
) {
  const result: DropdownOption[] = []

  currArray.forEach((elementA) => {
    const matchingElementB = newArray.find(
      (elementB) => elementB.value === elementA.value
    )

    if (matchingElementB) {
      const mergedChildren = mergeChildren(elementA, matchingElementB)
      result.push({ ...elementA, children: mergedChildren })
    } else {
      result.push(elementA)
    }
  })

  const newArrForgot = newArray.reduce((acc, curr) => {
    if (!result.map((item) => item.value).includes(curr.value)) {
      acc.push(curr)
    }

    return acc
  }, [] as DropdownOption[])

  return [...result, ...newArrForgot]
}

/** Merge two dropdown option children and get only unique
 * @param { DropdownOption } currDropdownGroupOption
 * @param { DropdownOption } newDropdownGroupOption
 * @returns { DropdownOption[] }
 */
export function mergeChildren(
  currDropdownGroupOption: DropdownOption,
  newDropdownGroupOption: DropdownOption
) {
  const mergedChildren = currDropdownGroupOption.children
    ? [...currDropdownGroupOption.children]
    : []

  newDropdownGroupOption.children?.forEach((newChild) => {
    const existingChild = mergedChildren.find(
      (child) => child.value === newChild.value
    )

    if (!existingChild) {
      mergedChildren.push(newChild)
    }
  })

  return mergedChildren
}

/**
 * Transform data response to Dropdown
 * @param { DeviceOptions } deviceOption
 * @param valuePath
 * @returns { DropdownOption }
 */
export function dataToDeviceOption(
  deviceOption: DeviceOptions,
  valuePath: 'id' | 'deviceno' = 'id'
): DropdownOption {
  const deviceIcon = new DeviceIconPipe()
  return {
    label: `${
      deviceOption.device.wingname ? deviceOption.device.wingname : '---'
    }, ${deviceOption.device.deviceno}`,
    id: deviceOption.device[valuePath]?.toString() || '',
    value: deviceOption.device[valuePath]?.toString() || '',
    entity: {
      hasIot: deviceOption.device.hasIot === 'true',
      icon: deviceIcon.transform(
        deviceOption.device.type as DeviceTypeEnum,
        'xs'
      ),
      name: deviceOption.device.wingname,
      deviceno: deviceOption.device.deviceno,
      type: deviceOption.device.type,
    },
  }
}
